import api from '@/api';
import { AdpDocumentBasicInfo, isDocument } from '@/types';
import { isAllianceMedia } from '@/utils/adpDocument';
import { setRedirectUrl } from '@/utils/rightClickOpenTab';
import { userSession } from '@/utils/userSession';

export const articleClickedEvent = async (
  viewProps: Parameters<typeof api.sendView>[0],
  adpDocument?: AdpDocumentBasicInfo,
) => {
  if (!adpDocument) return;
  if (!isDocument(adpDocument)) return;

  // 有料記事の場合はIsOpenedFromAdpDocumentCardLinkのlocal storageをtrueにして遷移する
  // 記事詳細画面ではIsOpenedFromAdpDocumentCardLink がtrueの場合は api.sendView を実行しない
  if (isAllianceMedia(adpDocument))
    userSession.setIsOpenedFromAdpDocumentCardLink(true);

  await api.sendView(viewProps);
};

export const articleContextMenuClickedEvent = (
  viewProps: Parameters<typeof api.sendView>[0],
  event: Event,
  adpDocument?: AdpDocumentBasicInfo,
) => {
  if (!adpDocument) return;
  if (!isDocument(adpDocument)) return;

  setRedirectUrl(event, viewProps);
};
